module.exports = __webpack_public_path__ + "static/media/BY.0e713aac.svg";